import request from '@/utils/changanRequest'
// 居民端-获取指定邻里中心的房源分页列表
export function WxGetLeasePage(params) {
  return request({
    url: 'system/lease/list',
    method: 'get',
    params
  })
}

// 房主端-获取我的房源
export function WxGetMyLeaseList(query) {
  return request({
    url: 'system/lease/list',
    method: 'get',
    params: query,
  })
}

// 居民端-获取我的房源详情
export function WxGetLease(id) {
  return request({
    url: 'system/lease/' + id,
    method: 'get',
  })
}
// 房主端-保存我的房源信息，用于新增或修改房源
export function WxSaveMyLease(data) {
  return request({
    url: 'system/lease',
    method: 'post',
    data,
  })
}


// 房主端-获取指定房源的预约单列表
export function WxGetPreRoomPage(params) {
  return request({
    url: 'system/preroom/list',
    method: 'get',
    params,
  })
}

// 查询房屋求租列表
export function listLessee(query) {
  return request({
    url: '/system/lessee/list',
    method: 'get',
    params: query
  })
}

// 新增房屋求租
export function addLessee(data) {
  return request({
    url: '/system/lessee',
    method: 'post',
    data: data
  })
}
// 查询房屋求租详细
export function getLessee(id) {
  return request({
    url: '/system/lessee/' + id,
    method: 'get'
  })
}
// 删除房屋求租
export function delLessee(id) {
  return request({
    url: '/system/lessee/' + id,
    method: 'delete'
  })
}
// 删场房源信息
export function DeleteLease(LeaseIds) {
  return request({
    url: "/system/lease/" + LeaseIds,
    method: "delete",
  });
}